import axiosClient from '../util/request';
import { plainToInstance } from 'class-transformer';
import AdmissionMetadata from '../../types/AdmissionMetadata';

/**
 * Returns current user admission data that is not related to the forms
 */
const getCurrentUserAdmissionMetaData = async (forceRefresh = false) : Promise<AdmissionMetadata> => {
  const admissionMetadata = window.localStorage.getItem('admission.metadata');

  if (admissionMetadata && !forceRefresh) {
    // @ts-ignore
    const result : AdmissionMetadata = plainToInstance(AdmissionMetadata, JSON.parse(admissionMetadata));

    if(Array.isArray(result)){
      return result[0];
    }
    return result;
  }

  const metadataResponse = await axiosClient.get<AdmissionMetadata>('/v1/users/my-data', {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  window.localStorage.setItem('admission.metadata', JSON.stringify(metadataResponse.data));

  return await getCurrentUserAdmissionMetaData(false);
};

const usersRepository = {
  getCurrentUserAdmissionMetaData,
};

export default usersRepository;